import styled from 'styled-components';

interface Props {
  isOpen?: boolean,
  isActive?: boolean,
  isMobile?: boolean,
}

const Select = styled.div`
  position: relative;
  width: 100%;
  height: 62px;
  font-size: 16px;
  cursor: pointer;

  select {
    display: ${(props: Props) => props.isMobile ? null: 'none'};
    opacity: ${(props: Props) => props.isMobile ? 0 : null};
    width: 100%;
    height: 100%;
    z-index: 10;
    position: absolute;
    top: 0;
    left: 0;
  }

  > div {
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0 , .1);
    border-radius: 4px;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #fff;
    padding: 8px 15px;
    display: flex;
    flex-direction: row;
    align-items: center;

    &:after {
      content: "";
      width: 0;
      height: 0;

    }

    &.inactive {
      color: #a3a3a3; 
    }
  }

  ul {
    display: ${(props: Props) => props.isOpen ? 'block' : 'none'};
    position: absolute;
    top: 115%;
    right: 0;
    left: 0;
    z-index: 10;
    margin: 0;
    padding: 0;
    list-style: none;
    background-color: #fff;
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0 , .1);
    border-radius: 4px;
    
    li {
      height: 60px;
      margin: 0;
      padding: 15px 0;
      text-indent: 15px;
      display: flex;
      flex-direction: row;
      align-items: center;

      &:not(:last-child) {
        border-bottom: 1px solid rgba(83, 83, 83, 0.1);
      }

      &.active {
        font-weight: bold;
      }
    }
  }
`;

export {
  Select,
}
